export enum ImprovementStatus {
  Lock = 'Lock',
  Unlock = 'Unlock',
  Bought = 'Bought',
}

export const ADDITIONAL_FROZEN_UNTIL_SECONDS = 5;
